module.exports = __webpack_public_path__ + "static/img/location.61163889.svg";